import axios from 'axios';
import {displayMessage} from '../../../helper';

export default {
    /**
     * get the orderInfo from Api and fetch it to the store
     * @param commit
     * @param dispatch
     */
    getSessionOrder({commit, dispatch}) {
        const task = 'sessionOrder/getSessionOrder';
        if(this.state.loadingTasks.indexOf(task) >= 0) {return;}
        dispatch('addLoadingTask', {task}, {root:true});

        return axios.get(window.apiEndpoints['s.order.get'])
            .then(res => {
                commit('updateSessionOrder', res.data.data);
                dispatch('removeLoadingTask', {task}, {root:true});
            });

    },
    /**
     * add order item to session order
     * @param commit
     * @param dispatch
     * @param product_id
     * @param qty
     * @param wines
     * @param add_ons
     */
    addOrderItem({commit, dispatch}, {product_id, qty, wines, add_ons}) {
        if(this.isLoading) {return;}
        const task = 'sessionOrder/addOrderItem';
        dispatch('addLoadingTask', {task}, {root:true});

        axios.post(window.apiEndpoints['s.order.item.add'], {
            product_id,
            qty,
            wines,
            add_ons
        })
            .then(res => {
                if(res.data.success && res.data.message !== null) {
                    const link = $('<a />', {
                        href: '#',
                        'text': window.language.view_cart,
                        'class': 'text-white ml-3 text-decoration-underline'
                    });
                    link.on('click', (e) => {
                        e.preventDefault();
                        window.popups.shoppingCartPopup.openPopup();
                    });
                    commit('updateSessionOrder', res.data.data.session_order);
                    window.toggleToast(res.data.message, 'success', link);
                }
            })
            .catch(err => {
                if(err.response && err.response.status === 422) {
                    displayMessage(err.response.data.message, 'error');
                }
            })
            .then(() => {
                dispatch('removeLoadingTask', {task}, {root:true});
            });
    },
    /**
     * remove order item by combination key
     * @param commit
     * @param dispatch
     * @param combination_key
     */
    removeOrderItemByCombinationKey({commit, dispatch}, {combination_key}) {
        if(this.isLoading) {return;}
        const task = 'sessionOrder/removeOrderItemByCombinationKey';
        dispatch('addLoadingTask', {task}, {root:true});

        axios.post(window.apiEndpoints['s.order.item.remove'], {
            type: 'combination_key',
            combination_key
        })
            .then(res => {
                if(res.data.success && res.data.message !== null) {
                    commit('updateSessionOrder', res.data.data.session_order);
                    displayMessage(res.data.message, 'success');
                }
            })
            .catch(err => {
                if(err.response && err.response.status === 422) {
                    displayMessage(err.response.data.message, 'error');
                }
            })
            .then(() => {
                dispatch('removeLoadingTask', {task}, {root:true});
            });
    },
    removeOrderItemById({commit, dispatch}, {id}) {
        if(this.isLoading) {return;}
        const task = 'sessionOrder/removeOrderItemById';
        dispatch('addLoadingTask', {task}, {root:true});

        console.log(id);

        axios.post(window.apiEndpoints['s.order.item.remove'], {
            type: 'id',
            id
        })
            .then(res => {
                if(res.data.success && res.data.message !== null) {
                    commit('updateSessionOrder', res.data.data.session_order);
                    displayMessage(res.data.message, 'success');
                }
            })
            .catch(err => {
                if(err.response && err.response.status === 422) {
                    displayMessage(err.response.data.message, 'error');
                }
            })
            .then(() => {
                dispatch('removeLoadingTask', {task}, {root:true});
            });
    },
    /**
     * update order item qty by combination key
     * @param commit
     * @param dispatch
     * @param combination_key
     * @param qty
     */
    updateOrderItemQty({commit, dispatch}, {combination_key, qty, errCb}) {
        if(this.isLoading) {return;}
        const task = 'sessionOrder/updateOrderItemQty';
        dispatch('addLoadingTask', {task}, {root:true});

        axios.post(window.apiEndpoints['s.order.item.qty.update'], {
            combination_key,
            qty
        })
            .then(res => {
                if(res.data.success && res.data.message !== null) {
                    commit('updateSessionOrder', res.data.data.session_order);
                    displayMessage(res.data.message, 'success');
                }
            })
            .catch(err => {
                if(err.response && err.response.status === 422) {
                    displayMessage(err.response.data.message, 'error');
                }
                errCb && errCb();
            })
            .then(() => {
                dispatch('removeLoadingTask', {task}, {root:true});
            });
    },
    /**
     * update add on item qty by combination key
     * @param commit
     * @param dispatch
     * @param combination_key
     * @param add_on_id
     * @param qty
     */
    updateAddOnQty({commit, dispatch}, {combination_key, add_on_id, qty, errCb}) {
        if(this.isLoading) {return;}
        const task = 'sessionOrder/updateAddOnQty';
        dispatch('addLoadingTask', {task}, {root:true});

        axios.post(window.apiEndpoints['s.order.item.add_on.qty.update'], {
            combination_key,
            add_on_id,
            qty
        })
            .then(res => {
                if(res.data.success && res.data.message !== null) {
                    commit('updateSessionOrder', res.data.data.session_order);
                    displayMessage(res.data.message, 'success');
                }
            })
            .catch(err => {
                if(err.response && err.response.status === 422) {
                    displayMessage(err.response.data.message, 'error');
                }
                errCb && errCb();
            })
            .then(() => {
                dispatch('removeLoadingTask', {task}, {root:true});
            });
    },
};